export const experienceList = [
  {
    title: "Abbott project",
    range: "2024",
    desc: "Worked on a microservice based on the Big Ten project, focused on collecting and displaying statistics related to blood donors. Developed features to manage and present donor information effectively.",
  },
  {
    title: "SoCon Project",
    range: "2024",
    desc: "Worked on the SoCon project, focusing on displaying statistics for tournament tables and game schedules related to the American conference. The project was integrated with the Big Ten project as a monolithic repository, allowing for parallel development and streamlined management of both projects.",
  },
  {
    title: "Telegram Bot Developer",
    range: "2023",
    desc: "Developed a Telegram bot using Node.js for Hope for Ukraine, a volunteer organization. The bot was designed to process and send reports to the general corporate channel, collecting various data such as photos, distribution dates, categories of assistance provided, and other relevant information",
  },
  {
    title: "Support developer, Boost project",
    range: "2023",
    desc: "Provided support for the Boost project, which was developed using Gatsby. Responsibilities included troubleshooting issues, implementing updates, and ensuring optimal performance of the application. Collaborated with the team to enhance features and improve user experience.",
  },
  {
    title: "Big Ten Project",
    range: "2022 – 2024",
    desc: "Worked on the Big Ten project, focusing on displaying tournament statistics, game schedules, and tournament tables for various sports. Responsibilities included creating, configuring, and adapting tables to effectively showcase sports events, ensuring a user-friendly interface. Collaborated with backend developers to integrate data and enhance the overall functionality of the project.",
  },
  {
    title: "Aircon Project",
    range: "2022",
    desc: "Contributed to the Aircon project, developing it from scratch over approximately 5 months. Collaborated with a team to design and implement features, ensuring high quality and functionality in the final product.",
  },
  {
    title: "Non-military service",
    range: "2020 - 2022",
    desc: "",
  },
  {
    title: "Freelance Mobile Application Developer",
    range: "2021",
    desc: "Worked on a mobile application for a church aimed at youth, featuring various sections including songs and psalms. The app was integrated with the church website to provide a seamless user experience and enhance community engagement.",
  },
  {
    title: "Freelance Web Content Manager & Video Editor",
    range: "2020",
    desc: "I worked as a freelancer for a church website, managing content, updating pages, and administering specific sections. Simultaneously, I created and edited video materials for the church using tools such as Photoshop, After Effects, Blender, Shotcut, and DaVinci Resolve. This role involved ensuring high-quality visual presentation of the website and media content, enhancing user engagement and the organization's overall image.",
  },
];
